import { Medal, Bug, Construction, Flag, KeyRound, LayoutDashboard, Mail, Megaphone, ScrollText, ShieldCheck, Shirt, UsersRound, type LucideIcon } from "lucide-react";

export interface AdminNavigationItem {
  label: string;
  to: string;
  icon: LucideIcon;
  end?: boolean | undefined;
  description?: string;
}
export interface AdminNavigationGroup {
  label?: string;
  items: AdminNavigationItem[];
}
export const defaultAdminNavigation: AdminNavigationGroup[] = [
  { items: [{ label: "Visão geral", to: "/", icon: LayoutDashboard, end: true }] },
  { label: "Gerenciar", items: [
    { label: "Jogadores", to: "/jogadores", icon: UsersRound, description: "Contas, perfis e economia dos jogadores." },
    { label: "Denúncias", to: "/denuncias", icon: Flag, description: "Analise denúncias e acompanhe a moderação." },
    { label: "Catálogo de avatares", to: "/avatares", icon: Shirt, description: "Itens e personalização disponíveis no jogo." },
    { label: "Cosméticos de perfil", to: "/cosmeticos", icon: Medal, description: "Ícones, molduras, medalhas e preços." },
    { label: "Clans", to: "/clans", icon: ShieldCheck, description: "Membros, progressão e gestão dos clans." }
  ] },
  { label: "Operações", items: [
    { label: "Bugs", to: "/bugs", icon: Bug, description: "Problemas enviados pelos jogadores e revisão da equipe." },
    { label: "Waitlist", to: "/waitlist", icon: Mail, description: "Volume de e-mails cadastrados antes do lançamento." },
    { label: "Manutenção do lobby", to: "/operacoes/manutencao", icon: Construction, description: "Disponibilidade de salas e novas partidas." },
    { label: "Anúncios globais", to: "/comunicacao/anuncios", icon: Megaphone, description: "Comunicados para os canais e salas do jogo." }
  ] },
  { label: "Governança", items: [
    { label: "Auditoria", to: "/auditoria", icon: ScrollText, description: "Histórico das operações administrativas." },
    { label: "Acessos e roles", to: "/acessos/roles", icon: KeyRound, description: "Roles e permissões da equipe." }
  ] }
];
